import {
  EquirectangularReflectionMapping,
  Object3D,
  SRGBColorSpace,
  TextureLoader,
} from "three";
import { Context } from "../../../context";
import { TimeOfDay } from "../../../util/clock";
import { getRandomElement } from "../../../../lib/misc/util";

export class SkyFallback extends Object3D {
  private skyboxes: { [key in TimeOfDay]: string[] } = {
    DAY: ["Skybox_A.jpg", "Skybox_B.jpg", "Skybox_C.jpg", "Skybox_D.jpg"],
    SUNSET: [
      "SkyboxSunset_A.jpg",
      "SkyboxSunset_B.jpg",
      "SkyboxSunset_C.jpg",
      "SkyboxSunset_D.jpg",
      "SkyboxSunset_E.jpg",
    ],
    NIGHT: ["SkyboxNight_A.jpg", "SkyboxNight_B.jpg", "SkyboxNight_C.jpg"],
  };
  private contextRef: Context;
  private currentTimeOfDay?: TimeOfDay;

  private loader = new TextureLoader();

  constructor(context: Context) {
    super();

    const assetBase = context.options.assetBase;

    if (assetBase) {
      this.loader.setPath(assetBase);
    }

    this.contextRef = context;
  }

  init() {
    this.update();
  }

  update() {
    const { clock, scene } = this.contextRef;

    const timeOfDay = clock.getTimeOfDay();
    if (timeOfDay == this.currentTimeOfDay) return;

    const filename = getRandomElement(this.skyboxes[timeOfDay]);
    const skyTexture = this.loader.load(`/images/skyboxes/${filename}`);

    skyTexture.colorSpace = SRGBColorSpace;
    skyTexture.mapping = EquirectangularReflectionMapping;
    scene.background = skyTexture;
    scene.environment = skyTexture;

    this.currentTimeOfDay = timeOfDay;
  }
}
